// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sidebar {
  width: var(--width-sidebar-close);
  height: 100vh;
  transition: width 0.35s ease;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-color: var(--dark);
  border-right: 1px solid var(--white);
  /* Sidebar abierto */
}
.sidebar.sidebar-open {
  width: var(--width-sidebar-open);
  /* Estilos específicos para el ítem de cierre */
}
.sidebar.sidebar-open .nav-item {
  justify-content: flex-start;
}
.sidebar.sidebar-open .close-item {
  display: flex;
  justify-content: flex-end;
}
.sidebar .nav-item {
  margin-bottom: 0.5rem;
  color: var(--white); /* Ensure text color matches navbar */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.sidebar .nav-item:has(.nav-link.active) {
  background-color: var(--primary);
}
.sidebar .nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-decoration: none;
  cursor: pointer;
  color: var(--white) !important;
}
.sidebar .nav-item .nav-link:hover {
  color: #cce4ff; /* Add hover effect similar to navbar */
}

@media (max-width: 767.98px) {
  .sidebar {
    width: 0;
  }
  .sidebar.sidebar-open {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iCAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,6BAAA;EACA,oCAAA;EACA,oBAAA;AAEF;AADE;EACE,gCAAA;EAIA,+CAAA;AAAJ;AAHI;EACE,2BAAA;AAKN;AAFI;EACE,aAAA;EACA,yBAAA;AAIN;AADE;EACE,qBAAA;EACA,mBAAA,EAAA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAGJ;AAFI;EACE,gCAAA;AAIN;AAFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,8BAAA;AAIN;AAHM;EACE,cAAA,EAAA,uCAAA;AAKR;;AACA;EACE;IACE,QAAA;EAEF;EADE;IACE,WAAA;EAGJ;AACF","sourcesContent":[".sidebar {\n  width: var(--width-sidebar-close);\n  height: 100vh;\n  transition: width 0.35s ease;\n  overflow: hidden;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1000;\n  background-color: var(--dark);\n  border-right: 1px solid var(--white);\n  /* Sidebar abierto */\n  &.sidebar-open {\n    width: var(--width-sidebar-open);\n    & .nav-item {\n      justify-content: flex-start;\n    }\n    /* Estilos específicos para el ítem de cierre */\n    & .close-item {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n  & .nav-item {\n    margin-bottom: 0.5rem;\n    color: var(--white); /* Ensure text color matches navbar */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    &:has(.nav-link.active) {\n      background-color: var(--primary);\n    }\n    & .nav-link {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n      text-decoration: none;\n      cursor: pointer;\n      color: var(--white) !important;\n      &:hover {\n        color: #cce4ff; /* Add hover effect similar to navbar */\n      }\n    }\n  }\n}\n\n@media (max-width: 767.98px) {\n  .sidebar {\n    width: 0;\n    &.sidebar-open {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
